import { API_ENDPOINT } from "../constants"
import { HTTP } from "./http"

export const DashBoardService = {
    getDBClients: (account_id:number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/resume-base-clients/${account_id}`);
    },
    getConversationsCards:(account_id:number)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/resume-conversations-targets/${account_id}`)
    },
    getConversationsPie: (account_id:number) =>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/resume-conversations-charts/${account_id}`)
    },
    getBulkSenders: (account_id:number,send_id:number) =>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/sendings-targets/${account_id}/${send_id}`)
    },
    chartAnswers: (account_id:number,send_id:number) =>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/sendings-chart-words/${account_id}/${send_id}`)
    },
    chartCategories: (account_id:number,send_id:number) =>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/sendings-chart-tipifications/${account_id}/${send_id}`)
    },
    getAgents:(account_id:number) =>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/resume-agents/${account_id}`)
    },
    getSubaccounts:(account_id:number) =>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/resume-sub-accounts/${account_id}`)
    },
    getShipmentList:(account_id:number)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/dash/sendings-gets/${account_id}`)
    },
    getConversations:(account_id:number, filter:string)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v4/dash/conversations/${account_id}?filter=${filter}`)
    },
    getAgentsMonitoring:(account_id:number, filter:string)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v4/dash/agents/${account_id}?filter=${filter}`)
    },
    getTipifications:(account_id:number,filter:string)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v4/dash/tipifications/${account_id}?filter=${filter}`)
    },
    getAgentsDetail:(account_id:number, filter:string)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v4/dash/agents-detail/${account_id}?filter=${filter}`)
    },
    closeSessionAgent:(agent_id: number)=>{
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}stadistics/closeSessionAgent`, { params: { agent_id } });
    },
    releaseTicketsAgent:(agent_id: number)=>{
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}stadistics/freeTicketsAgent`, { params: { agent_id } });
    }
}